import React from 'react';

import type { AxiosInstance } from 'axios';

const ApiState = React.createContext<AxiosInstance>(undefined as unknown as AxiosInstance);

export default ApiState;
